module.exports = __webpack_public_path__ + "static/boy-scouts@2x-895e9051e57950962eeb4ce7019889e1.png";